// extracted by mini-css-extract-plugin
module.exports = {"seasons":"SeasonSelect_seasons__pp9l5","season":"SeasonSelect_season__O6Sbi","active":"SeasonSelect_active__KLe3N","shimmer":"SeasonSelect_shimmer__b67DQ"};